export const BRAND = {
  name: 'DEMO',
  addressLine1: '',
  addressLine2: 'demo address',
  telephone: '077 0832 340',
  storageKey: 'ukauto',
  localStorageKey: 'ukauto',
  sessionStorageKey: 'ukauto',
};

export const formatAddress = () => `${BRAND.addressLine1}, ${BRAND.addressLine2}`;
